import useApiHook from "Hooks/ApiHook";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function DashboardWorkOrders() {
  /*   All States
   ********************************************* */
  const user = useSelector((state) => state?.user?.userInfo);

  /*   All Functions
   ********************************************* */

  const getDashboardWorkOrders = async () => {
    const response = await API.get("/dashboard/total-workorders", {
      headers: authHeader(),
    });
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(response.message);
    }
  };

  const {
    data: workOrdersData,
    loading: woLoading,
    error: woFetchError,
  } = useApiHook(() => {
    return getDashboardWorkOrders();
  });

  /*   All UseEffects
   ********************************************* */

  return (
    <div
      className="bg-white px-3 py-2 shadow-sm rounded"
      style={{ width: 600 }}
    >
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="fw-bold">Work Orders</h3>
        {(user?.permissions?.includes("work_orders_add") ||
          user?.permissions?.includes("work_orders_update") ||
          user?.permissions?.includes("work_orders_delete") ||
          user?.permissions?.includes("work_orders_dataEntry") ||
          user?.roles === "admin") && (
          <Link
            to="/work-orders/all?page=1&limit=10"
            className="btn btn-sm btn-success"
          >
            View
          </Link>
        )}
      </div>
      <hr className="mt-0 mb-2" />
      {woLoading || workOrdersData === null ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner variant="primary" />
        </div>
      ) : woFetchError ? (
        <div className="d-flex flex-column justify-content-center align-items-center h-75">
          <h4 className="text-danger text-center">Error</h4>
          <p className="text-center">{woFetchError}</p>
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-8 fw-bold">Total WorkOrders</div>
            <div className="col-4 text-end">
              {workOrdersData?.totalWorkOrders || "-"}
            </div>
          </div>
          <div className="row">
            <div className="col-8 fw-bold">With No Location</div>
            <div className="col-4 text-end">
              {workOrdersData?.withoutLocation || "-"}
            </div>
          </div>
          <div className="d-flex justify-content-between gap-5 align-items-start mt-2">
            <div className="w-50">
              <h4
                className="border-1 pe-2 fw-bold border-bottom "
                style={{ width: "fit-content" }}
              >
                By Location
              </h4>
              {Object.keys(workOrdersData?.byLocation).length &&
                Object.keys(workOrdersData?.byLocation).map((key) => (
                  <div className="row">
                    <div className="col-8 fw-bold">{key}</div>
                    <div className="col-4 text-end">
                      {workOrdersData?.byLocation[key]}
                    </div>
                  </div>
                ))}
            </div>
            <div className="w-50">
              <h4
                className="border-1 pe-2 fw-bold border-bottom "
                style={{ width: "fit-content" }}
              >
                By Status
              </h4>
              {Object.keys(workOrdersData?.byStatus).length &&
                Object.keys(workOrdersData?.byStatus).map((key) => (
                  <div className="row">
                    <div className="col-8 fw-bold">{key}</div>
                    <div className="col-4 text-end">
                      {workOrdersData?.byStatus[key]}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
